var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRdn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10 6.006h8.111c.098-.03.148.06.212.11a14.88 14.88 0 012.046 2.39 15.153 15.153 0 011.972 3.946c.482 1.484.71 3.054.65 4.614h-4.135a5 5 0 00.022-.624c-.043-1.471-.497-2.914-1.212-4.192-.765-1.369-1.833-2.55-3.047-3.531-1.322-1.069-2.81-1.913-4.36-2.595-.086-.04-.176-.072-.259-.118zm3.002 7.327a4715.11 4715.11 0 014.155 7.533c.333.606.67 1.21 1 1.817C16.436 23.785 14.72 24.897 13 26V13.333z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRdn);
export default __webpack_public_path__ + "static/media/rdn.e79bc7fd4979e477aff5168e167285d4.svg";
export { ForwardRef as ReactComponent };